<template>
    <div class="main-wrapper scroll-y custom-scrollbar with-tabs view-glass-shop-info">

        <page-title :title="'Szkło'" :back="false"></page-title>

        <div class="text-center">
            <slide-x-left-transition :duration="500">
                <img v-show="show" src="box-icon.png" style="max-width: 65%; margin-bottom: 1vh">
            </slide-x-left-transition>
            <slide-y-up-transition :duration="700" :delay="100">
                <hr v-show="show"/>
            </slide-y-up-transition>
            <slide-y-up-transition :duration="500" :delay="200">
                <p v-show="show">
                    <span>Jeśli chcesz zamówić szkło do Twojego lokalu,</span><br/>
                    <span>poinformuj o zapotrzebowaniu właściciela</span><br/>
                    <span>lub menedżera lokalu.</span>
                </p>
            </slide-y-up-transition>
            <slide-y-up-transition :duration="600" :delay="400">
                <p v-show="show">
                    <span>Zamówienie w naszym sklepie można złożyć</span><br/>
                    <span>tylko z poziomu ich konta na Portalu Gastro.</span>
                </p>
            </slide-y-up-transition>
            <slide-y-up-transition :duration="700" :delay="600">
                <p v-show="show">
                    <span>Dziękujemy.</span>
                </p>
            </slide-y-up-transition>
        </div>

    </div>
</template>

<script>
    import PageTitle from '@/components/PageTitle.vue';

    export default {
        name: 'ShopGlassInfo',
        components: { PageTitle },
        data(){
            return{
                show: false
            }
        },
        mounted(){
            this.show = true;
        }
    }
</script>